/** Límites Fase 1 — deben coincidir con backend/file_size_limits.py */

export const MAX_XML_BYTES = 1 * 1024 * 1024;
export const MAX_PDF_BYTES = 5 * 1024 * 1024;
export const FILE_TOO_LARGE_MESSAGE = "Archivo demasiado grande. Límite excedido.";

export function maxBytesLabel(maxBytes) {
  return `${Math.round(maxBytes / (1024 * 1024))} MB`;
}

/**
 * Separa archivos aceptados de los que exceden el límite.
 * @returns {{ accepted: File[], rejected: { name: string, size: number, limit: number }[] }}
 */
export function partitionFilesByMaxSize(files, maxBytes) {
  const accepted = [];
  const rejected = [];
  for (const file of files || []) {
    if (!file) continue;
    if (file.size > maxBytes) {
      rejected.push({ name: file.name || "archivo", size: file.size, limit: maxBytes });
    } else {
      accepted.push(file);
    }
  }
  return { accepted, rejected };
}

/** Mensaje estilo QMessageBox.warning para un archivo omitido. */
export function formatFileTooLargeWarning(name, limitBytes, kind = "XML") {
  const mb = maxBytesLabel(limitBytes);
  const ext = (name || "").toLowerCase();
  const isPdf = kind === "PDF" || ext.endsWith(".pdf");
  const tipo = isPdf ? "PDF" : "XML";
  const limite = isPdf ? maxBytesLabel(MAX_PDF_BYTES) : maxBytesLabel(MAX_XML_BYTES);
  return `El archivo '${name}' supera el límite de ${limite} (${tipo}) y no fue procesado.`;
}

/** Combina rechazos del cliente y del servidor en lista única de mensajes. */
export function collectTooLargeMessages(clientRejected, serverDetails = []) {
  const out = [];
  const seen = new Set();
  for (const r of clientRejected || []) {
    const msg = formatFileTooLargeWarning(r.name, r.limit, r.name?.toLowerCase().endsWith(".pdf") ? "PDF" : "XML");
    if (!seen.has(msg)) {
      seen.add(msg);
      out.push({ filename: r.name, message: msg });
    }
  }
  for (const row of serverDetails || []) {
    const name = row.filename || "archivo";
    const kind = row.kind || (name.toLowerCase().endsWith(".pdf") ? "PDF" : "XML");
    const limit = row.limit_bytes || (kind === "PDF" ? MAX_PDF_BYTES : MAX_XML_BYTES);
    const msg = row.message && row.message.includes(name)
      ? row.message
      : formatFileTooLargeWarning(name, limit, kind);
    if (!seen.has(msg)) {
      seen.add(msg);
      out.push({ filename: name, message: msg });
    }
  }
  return out;
}
